<template>
  <div>
    <v-btn
      @click="dialog = true"
      color="primary"
      class="ml-2"
    >
      Novo
    </v-btn>

    <SysDialog
      v-model="dialog"
      titulo="Novo menu de parametrização"
      @click:primary="salvarSubMenu()"
    >
      <Form
        :item="item"
        :dialog="dialog"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Form from './Includes/_form.vue';
import { salvarSubMenusConfiguracaoMenuParametrizacao } from '../../Api';

export default {
  components: { SysDialog, Form },
  data: () => ({
    dialog: false,
    item: {
      id_menu: '',
      descricao: '',
      url: ''
    }
  }),
  methods: {
    fecharDialog() {
      this.dialog = false;
      this.id_menu = '',
      this.item.descricao = '';
      this.url = ''
    },
    salvarSubMenu() {
      this.$store.dispatch(
        'loading/addRequisicao',
        salvarSubMenusConfiguracaoMenuParametrizacao(this.item)
          .then(() => this.$emit('atualizar-tela-inicial-menu-configuracao-sub-menu'))
          .catch(() => this.Helpers.logout())
          .finally(() => this.fecharDialog())
        );
    },
  }
}
</script>

<style>

</style>
